import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'

export default class IndexPage extends React.Component {
  render() {
    const { data } = this.props
    const { edges: posts } = data.allMarkdownRemark

    return (
      <div>
        {posts
          .map(({ node: post }) => (
            <article className="card mb-4">
              <header className="card-header">
                <div className="card-meta">
                  <a href="#">
                    <time className="timeago" dateTime={post.frontmatter.date}>{post.frontmatter.date}</time>
                  </a> in <a href="page-category.html">Journey</a>
                </div>
                <Link to={post.fields.slug}>
                  <h4 className="card-title">{post.frontmatter.title}</h4>
                </Link>
              </header>
              <Link to={post.fields.slug}>
                <img className="card-img" src={post.frontmatter.defaultImage} alt=""/>
              </Link>
              <div className="card-body">
                <p className="card-text">{post.excerpt}</p>
              </div>
            </article>
          ))}
      </div>
    )
  }
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] },
      filter: { frontmatter: { templateKey: { eq: "blog-post" } }}
    ) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          fields {
            slug
          }
          frontmatter {
            title
            templateKey
            date(formatString: "MMMM DD, YYYY")
            defaultImage
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js